<template>
    <div class="register-page">
        <main class="auth-page">
            <section class="auth-card">
                <div class="eyebrow">{{ getLabel('register.brandTag', 'VAST GPU NETWORK') }}</div>
                <h1 class="title">{{ getLabel('register.signUp', '创建账号') }}</h1>
                <p class="subtitle">{{ getLabel('register.subtitle', '注册 Vast.ai 账号，立即开启算力服务体验') }}</p>

                <form class="auth-form" @submit.prevent="submit">
                    <div class="field">
                        <label>{{ getLabel('new_lang.account', '账号') }}</label>
                        <div class="input-wrap has-prefix">
                          <span class="input-prefix">+91</span>
                            <input
                                v-model.trim="data.mobile"
                                type="text"
                                autocomplete="username"
                                autocapitalize="none"
                                spellcheck="false"
                                :placeholder="getLabel('register.phoneNumber', '请输入账号/手机号')"
                            >
                        </div>
                    </div>

                    <div class="field">
                        <label>{{ getLabel('new_lang.pwd', '登录密码') }}</label>
                        <div class="input-wrap password-wrap">
                            <input
                                v-model.trim="data.password"
                                :type="passwordVisible ? 'text' : 'password'"
                                autocomplete="new-password"
                                autocapitalize="none"
                                spellcheck="false"
                                :placeholder="getLabel('register.password', '请输入密码')"
                            >
                            <button
                                type="button"
                                class="eye-btn"
                                :aria-label="passwordVisible ? getLabel('register.hidePassword', '隐藏密码') : getLabel('register.showPassword', '显示密码')"
                                @click="togglePassword"
                            >
                                <van-icon :name="passwordVisible ? 'eye-o' : 'closed-eye'" />
                            </button>
                        </div>
                    </div>

                    <div class="field">
<!--                      <div v-if="showSmsField" class="field">  -->
                        <label>{{ getLabel('register.codeLabel', '验证码') }}</label>
                        <div class="input-wrap code-wrap">
                            <input
                                v-model.trim="data.code"
                                type="text"
                                inputmode="numeric"
                                :placeholder="getLabel('register.code', '请输入验证码')"
                            >
                            <button
                                type="button"
                                class="code-btn"
                                :disabled="codeSending || countdown > 0"
                                @click="sendcode"
                            >
                                {{ countdown > 0 ? countdown + getLabel('register.countdownSuffix', 's') : getLabel('register.sendCode', '获取验证码') }}
                            </button>
                        </div>
                    </div>

                    <div class="field">
                        <label>{{ getLabel('new_lang.recommend_code', '推荐码') }}</label>
                        <div class="input-wrap">
                            <input
                                v-model.trim="data.t_mobile"
                                type="text"
                                autocapitalize="none"
                                spellcheck="false"
                                :placeholder="getLabel('register.referralCode', '请输入推荐码')"
                            >
                        </div>
                    </div>

                    <button
                        type="submit"
                        class="submit-btn"
                        :disabled="submitLoading || !data.mobile || !data.password"
                    >
                        {{ submitLoading ? getLabel('utils.loading', '注册中...') : getLabel('register.signUpBtn', '立即注册') }}
                    </button>
                </form>

                <div class="auth-switch">
<!--                  已有账号-->
                    {{ getLabel('register.haveAccount', 'Already have an account?') }}
                    <router-link to="/login">{{ getLabel('register.signIn', 'Sign in now') }}</router-link>
                </div>
            </section>

            <div class="copyright">{{ getLabel('register.copyright', '© 2026 Vast.ai Compute Network') }}</div>
        </main>

        <button
            type="button"
            class="service-float"
            :aria-label="getLabel('user.onlineService', 'Online customer service')"
            @click="kefuTo"
        >
            <van-icon name="service-o" />
        </button>
    </div>
</template>

<script>
import Vue from "vue";
import { Icon, Toast } from "vant";
import Fetch from "../../utils/fetch";

Vue.use(Icon);
Vue.use(Toast);

export default {
    name: "Register",
    data() {
        return {
            passwordVisible: false,
            show_sms: 1,
            submitLoading: false,
            codeSending: false,
            countdown: 0,
            countdownTimer: null,
            appOriginalStyles: null,
            bodyOriginalBackground: "",
            config: {},
            data: {
                password: "",
                spassword: "",
                mobile: "",
                t_mobile: "",
                code: "",
                agent: 10000,
            },
        };
    },
    computed: {
        showSmsField() {
           // return Number(this.show_sms) > 0;
          return true;
        },
    },
    created() {
        this.$parent.footer("user", false);
        this.loadInviteParams();
        this.loadAgent();
    },
    mounted() {
        this.applyFullScreenLayout();
        this.loadConfig();
    },
    beforeDestroy() {
        this.restoreFullScreenLayout();
        this.clearCountdown();
    },
    methods: {
        getLabel(key, defaultText) {
            return this.$te(key) ? this.$t(key) : defaultText;
        },
        applyFullScreenLayout() {
            const app = document.getElementById("app");
            if (!app) {
                return;
            }

            this.appOriginalStyles = {
                maxWidth: app.style.maxWidth,
                width: app.style.width,
                margin: app.style.margin,
                backgroundColor: app.style.backgroundColor,
                paddingBottom: app.style.paddingBottom,
            };
            this.bodyOriginalBackground = document.body.style.background;

            app.style.maxWidth = "100%";
            app.style.width = "100%";
            app.style.margin = "0";
            app.style.backgroundColor = "#02050b";
            app.style.paddingBottom = "0";
            document.body.style.background = "#02050b";
        },
        restoreFullScreenLayout() {
            const app = document.getElementById("app");
            if (app && this.appOriginalStyles) {
                app.style.maxWidth = this.appOriginalStyles.maxWidth || "";
                app.style.width = this.appOriginalStyles.width || "";
                app.style.margin = this.appOriginalStyles.margin || "";
                app.style.backgroundColor = this.appOriginalStyles.backgroundColor || "";
                app.style.paddingBottom = this.appOriginalStyles.paddingBottom || "";
            }
            document.body.style.background = this.bodyOriginalBackground || "";
        },
        togglePassword() {
            this.passwordVisible = !this.passwordVisible;
        },
        kefuTo() {
            this.$router.push("/kefu");
        },
        loadInviteParams() {
            this.data.t_mobile = this.$route.query.m || this.data.t_mobile;
        },
        loadAgent() {
            if (this.$route.query.agent) {
                localStorage.setItem("agent", this.$route.query.agent);
                this.data.agent = this.$route.query.agent;
                return;
            }

            if (localStorage.getItem("agent")) {
                this.data.agent = localStorage.getItem("agent");
            }
        },
        async loadConfig() {
            try {
                const res = await Fetch("/index/webconfig", {
                    type: "web",
                });
                this.config = res.data || {};
                // this.show_sms = Number(res.data.sms_verify || 0);
              this.show_sms = 1;
            } catch (error) {
                this.config = {};
                this.show_sms = 0;
            }
        },
        startCountdown(seconds = 60) {
            this.clearCountdown();
            this.countdown = seconds;
            this.countdownTimer = setInterval(() => {
                if (this.countdown <= 1) {
                    this.clearCountdown();
                    return;
                }
                this.countdown -= 1;
            }, 1000);
        },
        clearCountdown() {
            if (this.countdownTimer) {
                clearInterval(this.countdownTimer);
                this.countdownTimer = null;
            }
            this.countdown = 0;
        },
        async sendcode() {

            if (this.codeSending || this.countdown > 0) {
                return;
            }

            if (!this.data.mobile) {
                this.$toast({
                    className: "toastName",
                    message: this.getLabel("register.phoneEmpty", "请输入账号/手机号"),
                });
                return;
            }

            this.codeSending = true;
            //console.log('this.data.mobile', "52" + this.data.mobile)
          //return
            try {
                await Fetch("/index/register_code", {
                    mobile: "91" + this.data.mobile,
                });

                this.$toast({
                    className: "toastName",
                    message: this.getLabel("register.sendSuccess", "发送成功"),
                });
                this.startCountdown(60);
            } catch (error) {
                // Fetch 内部已处理错误提示
            } finally {
                this.codeSending = false;
            }
        },
        async submit() {
            if (this.submitLoading) {
                return;
            }

            if (!this.data.mobile) {
                this.$toast({
                    className: "toastName",
                    message: this.getLabel("register.phoneEmpty", "Please enter your mobile phone number"), // 请输入手机号
                });
                return;
            }

            if (!this.data.password) {
                this.$toast({
                    className: "toastName",
                    message: this.getLabel("register.passwordEmpty", "Please enter your password"),  // 请输入密码
                });
                return;
            }

            if (this.showSmsField && !this.data.code) {
                this.$toast({
                    className: "toastName",
                    message: this.getLabel("register.codeEmpty", "Please enter the verification code"), // 请输入验证码
                });
                return;
            }

            this.submitLoading = true;

            try {
                const res = await Fetch("/index/register", {
                    ...this.data,
                });

                if (res.data.token) {
                    localStorage.setItem("token", res.data.token);
                }

                this.$toast({
                    className: "toastName",
                    message: this.getLabel("register.signUpSuccess", "Registration successful"),  // 注册成功
                });

                this.$router.replace("/");
            } catch (error) {
                // Fetch 内部已处理错误提示
            } finally {
                this.submitLoading = false;
            }
        },
    },
};
</script>

<style lang="less" scoped>
.register-page {
    min-height: 100vh;
    background:
        radial-gradient(circle at 78% 13%, rgba(24, 75, 255, 0.42), transparent 31%),
        radial-gradient(circle at 14% 52%, rgba(92, 42, 255, 0.17), transparent 26%),
        linear-gradient(180deg, #030815, #02050b 72%);
}

.auth-page {
    width: 100%;
    max-width: 430px;
    min-height: 100vh;
    margin: 0 auto;
    padding: 76px 18px 120px;
    box-sizing: border-box;
}

.auth-card {
    position: relative;
    padding: 42px 28px 30px;
    border-radius: 24px;
    background: linear-gradient(155deg, rgba(14, 31, 61, 0.98), rgba(7, 20, 42, 0.98));
    border: 1px solid rgba(68, 120, 221, 0.36);
    box-shadow: 0 24px 65px rgba(0, 0, 0, 0.46), inset 0 0 42px rgba(28, 74, 170, 0.08);
}

.auth-card::before {
    content: "";
    position: absolute;
    left: 8%;
    right: 8%;
    top: 0;
    height: 2px;
    background: linear-gradient(90deg, transparent, #3478ff, transparent);
    box-shadow: 0 0 18px #1765ff;
}

.eyebrow {
    color: #6b94ff;
    font-size: 12px;
    font-weight: 700;
    letter-spacing: 2px;
    text-transform: uppercase;
}

.title {
    margin: 10px 0 8px;
    color: #ffffff;
    font-size: 34px;
    line-height: 1.15;
    font-weight: 700;
}

.subtitle {
    margin: 0 0 34px;
    color: #8795af;
    font-size: 14px;
    line-height: 1.7;
}

.field {
    margin-bottom: 22px;

    label {
        display: block;
        margin-bottom: 10px;
        color: #dbe5f7;
        font-size: 14px;
        font-weight: 700;
    }
}

.input-wrap {
    position: relative;

    input {
        width: 100%;
        height: 72px;
        padding: 0 17px;
        border: 1px solid rgba(79, 111, 166, 0.25);
        border-radius: 16px;
        outline: none;
        background: #1b2940;
        color: #ffffff;
        font-size: 20px;
        box-sizing: border-box;
        box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.025);
        transition: border-color 0.2s, box-shadow 0.2s;
    }

    input:focus {
        border-color: #3276ff;
        box-shadow: 0 0 0 3px rgba(50, 118, 255, 0.13), 0 8px 24px rgba(13, 72, 200, 0.14);
    }

    input::placeholder {
        color: #71809b;
        font-size: 20px;
    }
}

.password-wrap input {
    padding-right: 54px;
}

.code-wrap input {
    padding-right: 132px;
}

.eye-btn,
.code-btn {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    border: 0;
    background: transparent;
}

.eye-btn {
    right: 14px;
    width: 30px;
    height: 30px;
    padding: 0;
    color: #8b9ab4;
    cursor: pointer;

    .van-icon {
        font-size: 24px;
    }
}

.code-btn {
    right: 16px;
    padding: 0;
    color: #4e88ff;
    font-size: 16px;
    font-weight: 700;
    cursor: pointer;
}

.code-btn:disabled {
    color: #71809b;
    cursor: not-allowed;
}

.submit-btn {
    width: 100%;
    height: 74px;
    margin-top: 8px;
    border: 0;
    border-radius: 17px;
    background: linear-gradient(90deg, #315eff, #247bff);
    color: #ffffff;
    font-size: 28px;
    font-weight: 800;
    box-shadow: 0 12px 30px rgba(35, 94, 255, 0.32);
    cursor: pointer;
    transition: transform 0.12s ease, filter 0.12s ease, opacity 0.12s ease;
}

.submit-btn:active {
    transform: scale(0.985);
    filter: brightness(0.92);
}

.submit-btn:disabled {
    opacity: 0.65;
    cursor: not-allowed;
}

.auth-switch {
    margin-top: 27px;
    text-align: center;
    color: #8795af;
    font-size: 14px;

    a {
        color: #4e88ff;
        text-decoration: none;
        font-weight: 800;
    }
}

.copyright {
    margin-top: 55px;
    text-align: center;
    color: #465167;
    font-size: 12px;
}

.service-float {
    position: fixed;
    right: max(18px, calc((100vw - 430px) / 2 + 18px));
    bottom: max(28px, env(safe-area-inset-bottom));
    z-index: 80;
    width: 64px;
    height: 64px;
    border: 1px solid rgba(156, 190, 255, 0.58);
    border-radius: 50%;
    background: linear-gradient(145deg, #337cff, #5939f3);
    color: #ffffff;
    box-shadow: 0 0 0 6px rgba(45, 91, 255, 0.1), 0 9px 24px rgba(21, 75, 255, 0.4);
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;

    .van-icon {
        font-size: 34px;
    }
}

@media (max-width: 360px) {
    .auth-page {
        padding-left: 12px;
        padding-right: 12px;
    }

    .auth-card {
        padding-left: 20px;
        padding-right: 20px;
    }

    .title {
        font-size: 30px;
    }

    .input-wrap input,
    .input-wrap input::placeholder {
        font-size: 18px;
    }

    .code-wrap input {
        padding-right: 110px;
    }

    .code-btn {
        font-size: 14px;
    }
}

.input-wrap.has-prefix {
  display: flex;
  align-items: center;
  /* 如果原来有 padding，改到 input 上，避免前缀被挤压 */
}

.input-wrap.has-prefix .input-prefix {
  flex: 0 0 auto;
  padding: 0 8px 0 12px;
  color: #F7F7F7;
  font-size: 18px;
  line-height: 1;
  border-right: 1px solid #DDDDDD; /* 可选，做分隔线 */
  margin-right: 8px;
  user-select: none;
}

.input-wrap.has-prefix input {
  flex: 1;
  border: none;
  outline: none;
  background: transparent;
  padding: 0 12px 0 0; /* 右侧保留内边距 */
}
</style>
